// extracted by mini-css-extract-plugin
export default {"SelectorWrapper":"Select_SelectorWrapper__ibmPf","title":"Select_title__4waL7","Select":"Select_Select__QWt5T","input":"Select_input__0AgpC","inp_label":"Select_inp_label__GdE5V"};